import { useState, useRef, useEffect } from "react";

const MARK_AS_OPTIONS = [
  {
    label: "Invoice cancelled",
    icon: "✕",
    danger: true,
  },
  {
    label: "Debit memo created",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="matrix(0.95 0 0 0.95 12 12)">
          <path
            style={{
              stroke: "none",
              strokeWidth: 1,
              fill: "currentColor",
              fillRule: "nonzero",
              opacity: 1,
            }}
            transform="translate(-12, -11.5)"
            d="M 20 9 L 12 1 L 4 9 L 9 9 L 9 21 C 9 21.552 9.448 22 10 22 L 14 22 C 14.552 22 15 21.552 15 21 L 15 9 L 20 9 L 20 9 z"
          />
        </g>
      </svg>
    ),
  },
  {
    label: "Credit memo created",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="matrix(0.95 0 0 0.95 12 12)">
          <path
            style={{
              stroke: "none",
              strokeWidth: 1,
              fill: "currentColor",
              fillRule: "nonzero",
              opacity: 1,
            }}
            transform="translate(-12, -12.5)"
            d="M 20 15 L 15 15 L 15 3 C 15 2.448 14.552 2 14 2 L 10 2 C 9.448 2 9 2.448 9 3 L 9 15 L 4 15 L 12 23 L 20 15 L 20 15 z"
          />
        </g>
      </svg>
    ),
  },
];
export default function MarkAsMenu({
  onSelect,
  invoice,
  userEmail,
  onStatusUpdate,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleSelect = (option) => {
    onSelect?.(option.label);
    setOpen(false);

    // Call the parent's status update function
    if (onStatusUpdate) {
      onStatusUpdate(option.label);
    }
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        type="button"
        onClick={() => setOpen((p) => !p)}
        className="fiori-btn-default"
      >
        Action
        <svg
          width="14"
          height="14"
          viewBox="0 0 20 20"
          fill="currentColor"
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.15s ease",
          }}
        >
          <path d="M5 7l5 5 5-5H5z" />
        </svg>
      </button>
      {open && (
        <div
          className="absolute right-0 mt-1 min-w-[210px] bg-white rounded-fiori border border-fiori-border-light shadow-fiori-popover overflow-hidden z-50"
          role="menu"
        >
          <div className="px-3 py-2 text-[11px] font-semibold uppercase tracking-wide text-fiori-text-secondary bg-fiori-page-2/60 border-b border-fiori-border-light">
            Mark as
          </div>
          {MARK_AS_OPTIONS.map((opt) => (
            <button
              key={opt.label}
              type="button"
              onClick={() => handleSelect(opt)}
              className={`flex items-center gap-2 w-full px-3 py-2 text-sm text-left hover:bg-fiori-card-hover transition-colors ${
                opt.danger ? "text-fiori-error" : "text-fiori-text"
              }`}
              role="menuitem"
            >
              <span className="inline-flex items-center justify-center w-4 h-4">
                {opt.icon}
              </span>
              <span className="font-medium">{opt.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
